<template>
    <form class="details-form">
        <div class="form-group row">
            <label for="linkedin-portfolio" class="col-sm-1 col-form-label">
                <img src='@/assets/brand-logos/linkedin.png' class="logo" />
            </label>
            
            <div class="col-sm-10">
                <input type="text" class="form-control" id="linkedin-portfolio" placeholder="Linkedin link">
            </div>

            <div class="col-sm-1">
            </div>
        </div>
        
        <div v-if="job_category === 'design' || from_profile === 'true'" class="form-group row">
            <label for="behance-portfolio" class="col-sm-1 col-form-label">
                <img src='@/assets/brand-logos/behance.png' class="logo" />
            </label>
            
            <div class="col-sm-10">
                <input type="text" class="form-control" id="behance-portfolio" placeholder="Behance link">
            </div>

            <div class="col-sm-1">
            </div>
        </div>


        <div v-if="job_category === 'dev' || from_profile === 'true'" class="form-group row">
            <label for="github-portfolio" class="col-sm-1 col-form-label">
                <img src='@/assets/brand-logos/github.png' class="logo" />
            </label>
            
            <div class="col-sm-10">
                <input type="text" class="form-control" id="github-portfolio" placeholder="Github link">
            </div>

            <div class="col-sm-1">
            </div>
        </div>


        <div v-if="job_category === 'design' || from_profile === 'true'" class="form-group row">
            <label for="dribbble-portfolio" class="col-sm-1 col-form-label">
                <img src='@/assets/brand-logos/dribbble.svg' class="logo" />
            </label>
            
            <div class="col-sm-10">
                <input type="text" class="form-control" id="dribbble-portfolio" placeholder="Dribbble link">
            </div>

            <div class="col-sm-1">
            </div>
        </div>
        
        <div class="form-group row">
            <label for="phone-number" class="col-sm-1 col-form-label">
                <i class="fa fa-phone" aria-hidden="true"></i>
            </label>
            
            <div class="col-sm-10">
                <input type="text" class="form-control" id="phone-number" placeholder="Phone Number (with country code)">
            </div>

            <div class="col-sm-1">
            </div>
        </div>

        <div class="form-group row">
            <label for="current-ctc" class="col-sm-1 col-form-label">
                <i class="fa fa-dollar" aria-hidden="true"></i>
            </label>
            
            <div class="col-sm-10">
                <input type="text" class="form-control" id="current-ctc" placeholder="Current Salary (include currency)">
            </div>
            
            <div class="col-sm-1">
            </div>
        </div>

        <div class="form-group row">

           <!-- <label for="notice-period" class="col-sm-1 col-form-label">
                <i class="fa fa-calendar" aria-hidden="true"></i>
            </label>
            
            <div class="col-sm-10">
                <input type="text" class="form-control" id="notice-period" placeholder="Notice Period (required)">
                <select class="form-control" id="notice-period">
                    <option>Available immediately</option>
                    <option>2 weeks</option>
                    <option>1 month</option>
                    <option>2 months</option>
                    <option>3 months</option>
                </select>
           
            </div>

            <div class="col-sm-1">
            </div> -->

        </div>
       

        
        <div v-if="resumeReqd" class="form-group row">
            <label for="resume-upload" class="col-sm-2 col-form-label">Resume
            </label>
            
            <div class="col-sm-9">
                <Dropzone id="resume-upload" @file="resumeReceived" class=""></Dropzone>
            </div>

            <div class="col-sm-2">
            </div>
        </div>
        <center>
        <ProgressButton @pressed="sendDetails"></ProgressButton>  
        </center>  
    </form>
</template>
    
    
<script>
import Dropzone from '@/components/Dropzone.vue'
import ProgressButton from '@/components/ProgressButton.vue'

//set resumeReqd prop to true if resume is mandatory. This should come from backend

export default {
    name: 'DetailsForm',
    props: {
        job_category: String,
        from_profile: String
    },
    data: function() {
        return {
            resume: null,
            resumeReqd: false,
            links: {
                behanceLink: null,
                dribbbleLink: null,
                linkedinLink: null,
                githubLink: null,
                phoneNumber: null,
                currentCTC: null,
            }
            
        }
    },
    components: {
        Dropzone,
        ProgressButton
    },
    methods: {
        resumeReceived: function(resume) {
            console.log("resume received is " + resume);
            this.resume = resume;
        }, 
        sendDetails: function() {
            if (this.job_category === 'design' || this.from_profile === 'true')
            this.links.behanceLink = document.getElementById("behance-portfolio").value;

            if (this.job_category === 'dev' || this.from_profile === 'true')
            this.links.githubLink = document.getElementById("github-portfolio").value;

            if (this.job_category === 'design' || this.from_profile === 'true')
            this.links.dribbbleLink = document.getElementById("dribbble-portfolio").value;

            this.links.linkedinLink = document.getElementById("linkedin-portfolio").value;
            this.links.phoneNumber = document.getElementById("phone-number").value;
            this.links.currentCTC = document.getElementById("current-ctc").value;


            if (this.resumeReqd)
            this.$emit('submit', this.resume, this.links);

            else {
                this.$emit('submit', null, this.links);
            }
        }
    }
}
</script>

<style scoped>
    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

    .details-form {
        margin-top:50px;
    }

    .logo {
        height:28px;
        width:28px;
        padding-bottom:2px;
    }

    .fa {
        font-size: 24px;
        margin-left: 6px;
        padding-bottom: 2px;
    }

</style>
